import crudHandlers from './_crud'

export default (state, action) => {
	state = crudHandlers(state, action, 'temporary_exit_reason')
	return state
}
